export class AppSettings {
     // public static API_ENDPOINT = 'http://localhost:8443/appcommerce/'; // local
     // public static API_ENDPOINT = 'http://3.101.26.3:8443/appcommerce/'; // DESARROLLO
     // public static API_ENDPOINT = 'http://54.215.166.83:8443/appcommerce/'; // QA ILC
      public static API_ENDPOINT = 'https://app.pasteleriailovechocolate.com/appcommerce/'; // Producción
      public static API_CREDENCIALES = 'dXNlcnNlcnZpY2lvczo3NWRjMjMwYTAwMGI1MjRiNzY2ZDZkOTg3NjVkYTkxODczNWY2YzI4';
     
}